import { PlusOutlined } from "@ant-design/icons";
import { Col, Input, Tag } from "antd";
import React, { useRef } from "react";
import { useBlogState } from "./blog-page-hooks";

export interface BlogTagsProps {}

export const BlogTags: React.FC<BlogTagsProps> = () => {
  const {
    loading,
    inputVisible,
    inputValue,
    tags,
    pageType,
    handleInputConfirm,
    setInputValue,
    setinputVisible,
  } = useBlogState();
  const inputEl = useRef(null);

  return !loading ? (
    <Col xs={24} md={14}>
      {tags.map((tag) => (
        <Tag
          closable
          onClose={(e) => {
            e.preventDefault();
          }}
        >
          {tag}
        </Tag>
      ))}
      {pageType !== "view" && inputVisible && (
        <Input
          ref={inputEl}
          type="text"
          size="small"
          style={{ width: 78 }}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      )}
      {pageType !== "view" && !inputVisible && (
        <Tag
          onClick={() => {
            setinputVisible(true);
            inputEl?.current?.focus();
          }}
          className="site-tag-plus"
        >
          <PlusOutlined /> New Tag
        </Tag>
      )}
    </Col>
  ) : null;
};

export default BlogTags;
